import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../userMaster/userMaster.scss";
import DeleteModal from "../../components/common/DeleteModal";
import UserDetailsModal from "../../components/userMaster/UserDetailsModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import DataFilter from "../../utils/DataFilter";
import DataSearch from "../../utils/DataSearch";
import FetchData, { DeleteEntry, AsyncCreateEntry } from "../../providers/dataProvider";
import { CheckNull } from "../../utils/Validate";
import { useRolePermission } from "../../hooks/useRolePermission";
import UserMasterFilter from "../../components/userMaster/UserMasterFilter";
import UserMasterGrid from "../../components/userMaster/UserMasterGrid";
import filterrSvg from "../../assets/images/funnel.svg";
import "../../assets/styles/filterDropdown.css"; // common CSS file, import mattum — edit pannala
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import ResetPasswordModal from '../userMaster/ResetPasswordModal';
import "../userMaster/userMaster.scss";
import "../userMaster/userMasterStyle.scss";

const UserMasterList = () => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState([]);
  const [filteredResults, setfilterResult] = useState([]);
  const [filterColumn, setFilterColumn] = useState([]);
  const [status, setStatus] = useState(null);
  const [clrFilter, setClrFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [refreshSearch, setRefreshSearch] = useState(false);
  const [deleteShow, setDeleteShow] = useState({ show: false, item: "" });
  const [resetShow, setResetShow] = useState({
    show: false,
    item: "",
    tempPassword: "",
    loading: false
  });
  const [createMsg, setCreateMsg] = useState(null);
  const [successShow, setSuccessShow] = useState(false);
  const { menuRights } = useRolePermission("User Master");
  const [activeFilterFields, setActiveFilterFields] = useState(["userType"]);
  const [UserFilter, setUserFilter] = useState({
    userType: "",
    companyName: [],
    userRole: [],
    status: [],
  });

  const statusdrp = [
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
  ];

  const userTypedrp = [
    { value: "1", label: "Employee" },
    { value: "2", label: "Distributor" },
  ];

  const { data: user, loading } = FetchData("userprofile");
  const { data: Company } = FetchData("company");
  const { data: Distributor } = FetchData("distributor");
  const { data: userRole } = FetchData("userrole");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const filterAnchorRef = useRef(null);

  // List That Id Convert into Name

  useEffect(() => {
    let filterdata = user.map((filterItem, index) => {
      let companyName = "";
      const companyValue = Company.find(function (item) {
        return item.id === filterItem.userCompanyId;
      });
      if (companyValue) {
        companyName = companyValue.companyName;
      } else {
        const distributorValue = Distributor.find(function (item) {
          return item.id === filterItem.userCompanyId;
        });
        if (distributorValue) {
          companyName = distributorValue.distributorName;
        }
      }

      filterItem.companyName = companyName;

      let userRoleName = "";
      var userRoleValue = userRole.filter(function (item) {
        return item.id === filterItem.roleId;
      });

      if (userRoleValue) userRoleName = userRoleValue[0]?.name;
      filterItem.userRoleName = userRoleName;
      filterItem.status = filterItem.isActive ? "Active" : "Inactive";
      filterItem.userTypeName =
        filterItem.userType === 1 ? "Employee" : "Distributor";

      filterItem.FullName = filterItem?.firstName + ' ' + filterItem?.lastName
      return filterItem;
    });

    filterdata = [...filterdata].sort(function (a, b) {
      return new Date(b.id) - new Date(a.id);
    });

    setUserData(filterdata);
  }, [user, Company, userRole, Distributor]);

  useEffect(() => {
    const getuserData = () => {
      if (userData) {
        setfilterResult(userData);
      }
    };
    getuserData();
  }, [userData]);

  useEffect(() => {
    const active = Object.values(UserFilter).some((value) =>
      Array.isArray(value) ? value.length > 0 : Boolean(value)
    );
    setHasActiveFilters(active);
  }, [UserFilter]);

  const [baseColumns] = useState([
    {
      heading: "User Name",
      value: "userName",
      sortable: true,
    },
    {
      heading: "First Name",
      value: "firstName",
      sortable: true,
    },

    {
      heading: "Last Name",
      value: "lastName",
      sortable: true,
    },
    {
      heading: "User Type",
      value: "userTypeName",
      sortable: true,
    },
    {
      heading: "Company Name",
      value: "companyName",
      sortable: true,
    },
    {
      heading: "Role",
      value: "userRoleName",
      sortable: true,
    },
    {
      heading: "Status",
      value: "status",
      sortable: true,
    },
    {
      heading: "Full Name",
      value: "FullName",
      sortable: true
    }
  ]);

  const [selected, setSelected] = useState([]);

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData === false) {
      setSelected((oldData) => [...oldData, e.target.value]);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };

  const handleEdit = (item) => {
    if (item)
      navigate("/add-new-user", {
        state: {
          userName: item?.userName,
          id: item?.id,
        },
      });
  };

  const handleResetPassword = (item) => {
    setResetShow({ show: true, item: item });
  };

  const handleCancelReset = () => {
    setResetShow({ show: false, item: "", tempPassword: "", loading: false });
  };


  const handleConfirmReset = async (item) => {
    setResetShow(prev => ({ ...prev, loading: true }));

    const result = await AsyncCreateEntry(
      "adminresetpassword",
      { identityId: item?.identityId },
      "Password reset successful",
      "Failed to reset password"
    );

    if (result?.status === 200) {
      const tempPwd = result?.successData?.temporaryPassword;
      setResetShow(prev => ({
        ...prev,
        loading: false,
        tempPassword: tempPwd
      }));
    } else {
      setResetShow({ show: false, item: "", tempPassword: "", loading: false });
      setCreateMsg(result);
    }
  };

  const handleDelete = (item) => {
    setDeleteShow({ show: true, item: item });
  };

  const handleCancelDelete = () => {
    setDeleteShow({ show: false, item: "" });
  };

  const handleConfirmDelete = (item) => {
    DeleteEntry(
      "userprofile",
      item,
      setCreateMsg,
      SuccessMessages?.DELETED("User Master"),
      ErrorMessages?.DELETED_ERROR("User Master"),
      () => {
        const updatedItems = user.filter((x) => x.id !== item.id);
        setfilterResult(updatedItems);
      }
    );
    setDeleteShow({ show: false, item: "" });
  };

  //Filter
  const handleStatusFilterChange = (selectedOption) => {
    setStatus(selectedOption);
    setUserFilter({
      ...UserFilter,
      status: selectedOption ? [selectedOption.label] : [],
    });
  };

  //UserType
  const [userType, setUserType] = useState([]);
  const prevUserTypeCategory = useRef(userType?.value);

  const handleUserFilterChange = (selectedOption) => {
    if (selectedOption) {
      let userTypeValue;

      if (Array.isArray(selectedOption)) {
        userTypeValue = selectedOption.map(({ value }) => value);
      } else {
        userTypeValue = selectedOption.value;
      }

      setUserType(selectedOption);
      setUserFilter({ ...UserFilter, userType: userTypeValue });
    } else {
      setUserType(null);
      setUserFilter({ ...UserFilter, userType: null });
    }
  };

  //CompanyName

  const [companyName, setcompanyName] = useState(null);
  const [CompanyData, setCompanyData] = useState([]);
  const [CompanyDatadrp, setCompanyDatadrp] = useState([]);

  useEffect(() => {
    setCompanyData(Company);
  }, [Company]);

  const formatCompanydrp = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.companyName,
      value: data?.id,
    }));
    return te;
  };

  useEffect(() => {
    const getCompanyData = () => {
      if (CompanyData) {
        const list = formatCompanydrp(CompanyData);
        setCompanyDatadrp(list);
      }
    };
    getCompanyData();
  }, [CompanyData]);

  //Distributor
  const [DistributorData, setDistributorData] = useState([]);
  const [DistributorDatadrp, setDistributorDatadrp] = useState([]);

  useEffect(() => {
    setDistributorData(Distributor);
  }, [Distributor]);

  const formatDistributordrp = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.distributorName,
      value: data?.id,
    }));
    return te;
  };

  useEffect(() => {
    const getDistributorData = () => {
      if (DistributorData) {
        const list = formatDistributordrp(DistributorData?.filter(item => item?.defaultCompanyDistributor !== true));
        setDistributorDatadrp(list);
      }
    };
    getDistributorData();
  }, [DistributorData]);

  const handleCompanyFilterChange = (selectedOption) => {
    setcompanyName(selectedOption);
    setUserFilter({
      ...UserFilter,
      userCompanyId: selectedOption ? [selectedOption.value] : [],
    });
  };

  useEffect(() => {
    const currentCategory = userType?.value;
    if (prevUserTypeCategory.current !== currentCategory) {
      setcompanyName(null);
      setUserRole(null);
      prevUserTypeCategory.current = currentCategory;
    }
  }, [userType]);

  //User Role

  const [UserRole, setUserRole] = useState(null);
  const [userRoleData, setUserRoleData] = useState([]);
  const [userRoleDatadrp, setUserRoleDatadrp] = useState([]);

  useEffect(() => {
    setUserRoleData(userRole);
  }, [userRole]);

  useEffect(() => {
    const getCompanyData = () => {
      if (userRoleData) {
        const formattedList = formatUserRoledrp(userRoleData);
        const filteredList =
          userType?.value === "2"
            ? formattedList.filter((item) => item?.distributorRole)
            : formattedList.filter((item) => !item?.distributorRole);
        setUserRoleDatadrp(filteredList);
      }
    };
    getCompanyData();
  }, [userRoleData, userType]);

  const formatUserRoledrp = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.name,
      value: data?.id,
      distributorRole: data?.onlyForDistributor,
    }));
    return te;
  };

  const handleRoleFilterChange = (selectedOption) => {
    setUserRole(selectedOption);
    setUserFilter({
      ...UserFilter,
      roleId: selectedOption ? [selectedOption.value] : [],
    });
  };

  //successShow

  const SuccessDoneClick = () => {
    setSuccessShow(false);
    navigate(0);
  };

  useEffect(() => {
    if (CheckNull(createMsg?.message) !== "") {
      setDeleteShow({ show: false, item: "" });
      setSuccessShow(true);
    }
  }, [createMsg]);

  const ClearFilter = () => {
    setUserFilter({
      userType: [],
      companyName: [],
      userRole: [],
      status: [],
    });
    setcompanyName(null);
    setUserType(null);
    setUserRole(null);
    setStatus(null);
    setClrFilter(true);
  };

  const RefreshList = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (clrFilter === true) {
      ApplyFilter();
    }
  }, [clrFilter]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      ApplySearch();
    }
  };

  //Apply Filter
  const ApplyFilter = () => {
    let filterResult = [];
    filterResult = DataFilter(userData, UserFilter);
    filterResult = DataSearch(
      filterResult,
      search,
      baseColumns.filter(({ value }) => !value.includes("status"))
    );
    filterResult = [...filterResult].sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setfilterResult(filterResult);
    setClrFilter(false);
  };

  const ApplySearch = () => {
    let SearchResult = [];
    SearchResult = DataSearch(
      userData,
      search,
      baseColumns.filter(({ value }) => !value.includes("status")))
    SearchResult = DataFilter(SearchResult, UserFilter);
    SearchResult = [...SearchResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setfilterResult(SearchResult);
    setRefreshSearch(false);
  };

  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [baseColumns, selected]);

  useEffect(() => {
    if (refreshSearch === true) ApplySearch();
  }, [search]);

  const removeSearch = () => {
    setSearch("");
    setRefreshSearch(true);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (value === "") {
      setRefreshSearch(true);   // auto-revert when box becomes empty via backspace too
    }
  };

  const handleView = (item) => {
    menuRights?.canView &&
      navigate("/view-user", {
        state: item,
        canView: menuRights?.canView,
      });
  };

  const addNew = () => { navigate('/add-new-user', { state: { canAdd: menuRights?.canAdd, canEdit: menuRights?.canEdit } }) }

  // keep this filter (still needed, just done before passing to filter component)
  const distributorForFilter = DistributorData?.filter(
    (item) => item?.defaultCompanyDistributor !== true
  );

  const userRoleForFilter = userRoleData?.filter((item) =>
    userType?.value === "2" ? item?.onlyForDistributor : !item?.onlyForDistributor
  );

  return (
    <><section className="company-master-list-sec" id="userMasterList">
      <div className="container-fluid">
        <div className="row pt-1">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0">
            <div className="card">
              <div className="card-body">
                <div className="row search-area-row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                    <div>
                      <p>{filteredResults?.length} Results Found</p>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto p-0">
                    <div className='d-flex flex-wrap flex-sm-nowrap justify-content-end justify-content-sm-end'>
                      <div className="search-section">
                        <div className="input-group text-align">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={search}
                            onKeyDown={handleKeyPress}
                            onChange={handleSearchChange}
                          />
                          <div className="input-group-append">
                            {search !== "" && (
                              <button className="btn" type="button" onClick={removeSearch}>
                                <i className="fas fa-times"></i>
                              </button>
                            )}
                            <button
                              className="btn"
                              type="button"
                              onClick={ApplySearch}
                            >
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                          <div className="text-align dropdown filter-dropdown quote-filter-control" ref={filterAnchorRef}>
                            <button
                              className={`btn filter-btn ${hasActiveFilters ? "filter-active" : ""}`}
                              type="button"
                              id="filterDropdown"
                              aria-haspopup="true"
                              aria-expanded={isFilterOpen}
                              onClick={() => setIsFilterOpen((currentValue) => !currentValue)}
                              title="Advanced filters"
                              style={{
                                borderTopLeftRadius: "0px",
                                borderBottomLeftRadius: "0px",
                                borderTopRightRadius: "8px",
                                borderBottomRightRadius: "8px",
                              }}
                            >
                              <span><img src={filterrSvg} alt="Filter" /></span>
                            </button>
                            {isFilterOpen && (
                              <UserMasterFilter
                                userTypedrp={userTypedrp}
                                handleUserFilterChange={handleUserFilterChange}
                                userType={userType}
                                DistributorData={distributorForFilter}
                                CompanyData={CompanyData}
                                handleCompanyFilterChange={handleCompanyFilterChange}
                                companyName={companyName}
                                userRoleData={userRoleForFilter}
                                handleRoleFilterChange={handleRoleFilterChange}
                                UserRole={UserRole}
                                statusdrp={statusdrp}
                                handleStatusFilterChange={handleStatusFilterChange}
                                ClearFilter={ClearFilter}
                                ApplyFilter={ApplyFilter}
                                status={status}
                                onCloseFilter={() => setIsFilterOpen(false)}
                                positioningTargetRef={filterAnchorRef}
                                activeFields={activeFilterFields}
                                setActiveFields={setActiveFilterFields}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="text-align">
                        <button className="btn refresh-btn" type="button" onClick={() => RefreshList()}>
                          <i className="fas fa-redo"></i>
                        </button>
                      </div>

                      {menuRights?.canAdd === true && (
                        <div className="text-right">
                          <button className="btn add-new-btn" type="button" onClick={addNew}>
                            Add New
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* <!-- search-area-sec ends --> */}
              </div>
            </div>
          </div>
        </div>
        <UserMasterGrid
          filteredResults={filteredResults}
          filterColumn={filterColumn}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleView={handleView}
          handleResetPassword={handleResetPassword}
          loading={loading}
          menuRights={menuRights}
          moduleName="User" />
      </div>
    </section>
      <div className="container-fluid user-master-list-sec pl-5 pr-5">

        {/* <!-- deleteModal--> */}
        <DeleteModal show={deleteShow.show} item={deleteShow.item} handleCancelDelete={handleCancelDelete}
          handleConfirmDelete={handleConfirmDelete} CodeName="User Name" CodeNo="Code Number" />

        <ResetPasswordModal
          show={resetShow.show}
          item={resetShow.item}
          tempPassword={resetShow.tempPassword}
          loading={resetShow.loading}
          handleCancel={handleCancelReset}
          handleConfirm={handleConfirmReset} />

        <SaveSuccessModel show={successShow} createMsg={createMsg} setShow={setSuccessShow} SuccessDoneClick={SuccessDoneClick} />

        {/* <!-- userDetailsModal--> */}
        <UserDetailsModal />
      </div></>
  );
};

export default UserMasterList;
